import { create } from 'zustand'

export const useAuthStore = create((set) => ({
  ready: false,
  authenticated: false,
  profile: null,

  setReady: (v) => set({ ready: v }),
  setAuth: (authenticated, profile = null) => set({ authenticated, profile }),
  reset: () => set({ ready: false, authenticated: false, profile: null }),
}))
